import { BrandDetailsPage } from '../../campaigns/BrandDetailsPage/BrandDetailsPage';
import { AgencyDetailsPage } from '../../campaigns/AgencyDetailsPage/AgencyDetailsPage';
import { ChannelGroupsPage } from '../../campaigns/channelGroups/components/ChannelGroupsPage/ChannelGroupsPage';
import { AgencyCampaignContext } from '../../campaigns/agencyCampaignContext';
import { BrandsPage } from '../../campaigns/brands/BrandsPage';
import { CampaignsPage } from '../../campaigns/campaigns/CampaignsPage';
import { CampaignOverviewPage } from '../../campaigns/campaigns/components/CampaignOverviewPage/CampaignOverviewPage';
import { CreativesPage } from '../../campaigns/creatives/CreativesPage/CreativesPage';
import { useParams, useSearch } from '@tanstack/react-router';
import { useShigoSession } from '../../../lib/useShigoSession';
import { assignedAgencies } from '../../auth/agencyAccess';
import { AgencyCampaignSection } from '../model';
import { CreativeTab } from '../../campaigns/creatives/model';
import { dashboardT } from '../../../lib/messages';
import { AgencyCreativeEditorContent } from './AgencyCreativeEditorContent';
import { AgencyLineItemsContent } from './AgencyLineItemsContent';
import { AgencySupplyContent } from './AgencySupplyContent';

function AgencyCampaignsContent({ section }: { section: AgencyCampaignSection }) {
  const routeSearch = useSearch({ from: '/a/$agencyId_/campaigns/$section' });
  if (section === AgencyCampaignSection.LineItems) return <AgencyLineItemsContent />;
  if (section === AgencyCampaignSection.Creatives && routeSearch.editor)
    return <AgencyCreativeEditorContent />;
  switch (section) {
    case AgencyCampaignSection.Supply:
      return <AgencySupplyContent />;
    case AgencyCampaignSection.ChannelGroups:
      return <ChannelGroupsPage />;
    case AgencyCampaignSection.Brands:
      return <BrandsPage />;
    case AgencyCampaignSection.Campaigns:
      return routeSearch.campaign ? (
        <CampaignOverviewPage campaignId={routeSearch.campaign} />
      ) : (
        <CampaignsPage />
      );
    case AgencyCampaignSection.Creatives:
      return <CreativesPage tab={routeSearch.creativeTab ?? CreativeTab.Display} />;
    default:
      return (
        <main className="p-6">
          <p>{dashboardT('agencyWorkspace.unavailable')}</p>
        </main>
      );
  }
}

export function AgencyCampaignsPage({
  section,
  brandId,
  agencyOverview = false,
}: {
  section: AgencyCampaignSection;
  brandId?: string | undefined;
  agencyOverview?: boolean;
}) {
  const { agencyId } = useParams({ strict: false });
  const { session } = useShigoSession();
  const agency = assignedAgencies(session?.user).find(({ id }) => id === agencyId);
  if (!agency) return null;
  return (
    <AgencyCampaignContext value={{ agency }}>
      {agencyOverview ? <AgencyDetailsPage agencyId={agency.id} /> : null}
      {brandId ? <BrandDetailsPage brandId={brandId} /> : null}
      {!agencyOverview && !brandId ? <AgencyCampaignsContent section={section} /> : null}
    </AgencyCampaignContext>
  );
}
